import { sections } from "../repositories";

export default {
  getSection: async (id: string, callback: (data?: any, err?: any) => void) => {
    try {
      const rs = await sections.getSection(id);
      callback(rs, null);
    } catch (error) {
      callback(null, error);
    }
  },
  getSections: async (ids: any, callback: (data?: any, err?: any) => void) => {
    try {
      const rs = await sections.getSections(ids);
      callback(rs, null);
    } catch (error) {
      callback(null, error);
    }
  },
};
